import { FILE_UPLOAD_CONSTANTS } from './constants';
import { formatFileSize } from './fileUtils';

/**
 * Validate if file meets Salesforce MIAW API requirements
 * @param {File} file - File object from input or clipboard
 * @returns {Object} - { valid: boolean, error: string, details?: object }
 */
export function validateFile(file) {
    if (!file) {
        return { valid: false, error: 'NO_FILE' };
    }

    // Check file size (5 MB max)
    if (file.size > FILE_UPLOAD_CONSTANTS.MAX_FILE_SIZE) {
        return {
            valid: false,
            error: 'FILE_TOO_LARGE',
            details: {
                size: file.size,
                maxSize: FILE_UPLOAD_CONSTANTS.MAX_FILE_SIZE,
                sizeMB: (file.size / 1024 / 1024).toFixed(2),
                maxSizeMB: (FILE_UPLOAD_CONSTANTS.MAX_FILE_SIZE / 1024 / 1024).toFixed(2)
            }
        };
    }

    // Check file type
    const allSupportedTypes = [
        ...FILE_UPLOAD_CONSTANTS.SUPPORTED_IMAGE_TYPES,
        ...FILE_UPLOAD_CONSTANTS.SUPPORTED_DOC_TYPES
    ];

    if (!allSupportedTypes.includes(file.type)) {
        return {
            valid: false,
            error: 'INVALID_FILE_TYPE',
            details: {
                fileType: file.type,
                supportedTypes: FILE_UPLOAD_CONSTANTS.SUPPORTED_FILE_TYPES_DISPLAY
            }
        };
    }

    return { valid: true, error: null };
}

/**
 * Check if file is an image
 * @param {File} file - File object
 * @returns {boolean}
 */
export function isImageFile(file) {
    return file && FILE_UPLOAD_CONSTANTS.SUPPORTED_IMAGE_TYPES.includes(file.type);
}

// Re-export formatFileSize for convenience
export { formatFileSize } from './fileUtils';
